import styled from 'styled-components';

export const RedAsterisk = styled.span`
    color: ${({ theme }) => theme.colors.error.error50};
`;
